/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Zotero_Thesis_MetaInputs */

const en_why_listening_zotero_thesis_meta = /** @type {(inputs: Why_Listening_Zotero_Thesis_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thesis · Chapter 2`)
};

const es_why_listening_zotero_thesis_meta = /** @type {(inputs: Why_Listening_Zotero_Thesis_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tesis · Capítulo 2`)
};

/**
* | output |
* | --- |
* | "Thesis · Chapter 2" |
*
* @param {Why_Listening_Zotero_Thesis_MetaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_zotero_thesis_meta = /** @type {((inputs?: Why_Listening_Zotero_Thesis_MetaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Zotero_Thesis_MetaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_zotero_thesis_meta(inputs)
	return en_why_listening_zotero_thesis_meta(inputs)
});